import { render, staticRenderFns } from "./digitalinvites.vue?vue&type=template&id=7bc4a8dc&"
import script from "./digitalinvites.vue?vue&type=script&lang=js&"
export * from "./digitalinvites.vue?vue&type=script&lang=js&"
import style0 from "./digitalinvites.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports